import styled from 'styled-components';
import { convertToTransientProps, getSpacing } from '../../../../utils/index.js';

const ModalContent = styled.div ``;
const Header = styled.div.withConfig({
    shouldForwardProp: convertToTransientProps(['width']),
}) `
  display: flex;
  flex-direction: column;
  padding: ${getSpacing('s03', 's04')};
  max-width: ${(props) => props.width}px;
`;
const Title = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${getSpacing('s05')};
  font-weight: ${(props) => props.theme.font.weightExtrabold};
`;
const CalendarsWrapper = styled.div `
  height: 50vh;
  overflow: auto;
`;

export { CalendarsWrapper, Header, ModalContent, Title };
